module.exports = __webpack_public_path__ + "static/img/02.110c95cc.jpeg";